<template>
    <CRow>
        <CModal :title="$lang.cancellationPolicy.crud.edit" size="lg" :show.sync="largeModal" :no-close-on-backdrop="true" color="primary">
            <CAlert :color="messageColorModal" closeButton :show.sync="dismissCountDownModal" fade >{{ err_msg }} </CAlert>
            <CForm novalidate @submit.prevent="onSubmit">
                <CCardBody>
                    <CRow class="align-items-start">
                        <CCol>
                            <div class="form-group">
                                <label class="form__label">
                                    {{ $lang.cancellationPolicy.form.hoursBefore }}
                                </label>
                                <input
                                    type="number"
                                    :placeholder="$lang.cancellationPolicy.form.hoursBefore"
                                    class="form-control"
                                    v-model="cancellationPolicyUpdate.hoursBefore"
                                />
                            </div>
                        </CCol>
                        <CCol>
                            <div class="form-group">
                                <label class="form__label">
                                    {{ $lang.cancellationPolicy.form.karmaPoint }}
                                </label>
                                <input
                                    type="number"
                                    :placeholder="$lang.cancellationPolicy.form.karmaPoint"
                                    class="form-control"
                                    v-model="cancellationPolicyUpdate.karmaPoint"
                                />
                            </div>
                        </CCol>
                        <CCol>
                            <div class="form-group">
                                <label class="form__label">
                                    {{ $lang.cancellationPolicy.form.returnPercentage }}
                                </label>
                                <input
                                    type="number"
                                    :placeholder="$lang.cancellationPolicy.form.returnPercentage"
                                    class="form-control"
                                    v-model="cancellationPolicyUpdate.returnPercentage"
                                />
                            </div>
                        </CCol>
                    </CRow>
                    <hr />
                    <CRow class="align-items-start">
                        <CCol>
                            <div class="form-group">
                                <label class="form__label">&nbsp;</label>
                                <CButton type="submit" size="sm" color="primary">
                                    <CIcon name="cil-check-circle" />
                                    {{ $lang.buttons.general.crud.submit }}
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CForm>
            <template #footer style="display: none;padding: 0px;border-top: 0px solid;">
                <div> </div>
            </template>
        </CModal>
        <CCol col="12">
            <CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade >{{ err_msg }} </CAlert>
            <CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>Cancellation Policy</strong>
						</CCol>
						<CCol sm="6" class="align-self-center">
							<div class="text-sm-right mt-3 mt-sm-0">
							</div>
						</CCol>
					</div>
				</CCardHeader>
				<CCardBody>
                    <v-server-table
                        :key="tableKey"
                        :url="module.api.list"
                        :columns="columns"
                        :options="options"
                        ref="myTable"
                        :data="data"
                        @loaded="onDataLoaded">
                            <template #actions="data">
                                <CButton
                                    color="success"
                                    v-c-tooltip="$lang.buttons.general.crud.edit"
                                    v-on:click="editTableRow(data.row.id)"
                                    v-if="checkPermission('edit-group-category-type')"
                                >
                                    <i class="fas fa-pencil-alt"></i>
                                </CButton>
                            </template>
                    </v-server-table>
				</CCardBody>
			</CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { cancellationPolicy } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueJsonToCsv from "vue-json-to-csv";
import store from "@/store/store";
import required_span from "../../components/layouts/general/required-span";
import {required} from "vuelidate/lib/validators";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
    name: "CancellationPolicy",
    mixins: [Mixin],
    components: {
        VueJsonToCsv,
        required_span,
    },
    data() {
        return {
            messageColor: "success",
            messageColorModal: "danger",
            err_msg: "",
            alertMessage: "",
            showAlert: false,
            dismissCountDownModal: 0,
            dismissCountDown: 0,
            dismissCountDownS: 0,
            self: this,
            activePage: 1,
            module: cancellationPolicy,
            json_data: [],
            json_label: {},
            json_title: "",
            tableKey: 0, // Add a key to force table reload
            data: [],
            largeModal: false,
            submitted: false,
            cancellationPolicyUpdate: {
                id: "",
                hoursBefore: "",
                karmaPoint: 0,
                returnPercentage: 0,
            },
            columns: [
                this.$lang.cancellationPolicy.table.columns.userType,
                this.$lang.cancellationPolicy.table.columns.hoursBefore,
                this.$lang.cancellationPolicy.table.columns.karmaPoint,
                this.$lang.cancellationPolicy.table.columns.pointType,
                this.$lang.cancellationPolicy.table.columns.returnPercentage,
                this.$lang.cancellationPolicy.table.columns.actions,
            ],
            options: {
                headings: {
                    userType: this.$lang.cancellationPolicy.table.userType,
                    hoursBefore: this.$lang.cancellationPolicy.table.hoursBefore,
                    karmaPoint: this.$lang.cancellationPolicy.table.karmaPoint,
                    pointType: this.$lang.cancellationPolicy.table.pointType,
                    returnPercentage: this.$lang.cancellationPolicy.table.returnPercentage,
                    actions: this.$lang.cancellationPolicy.table.actions,
                },
                sortable: [this.$lang.cancellationPolicy.table.createdAt, this.$lang.cancellationPolicy.table.isActive],
                filterable: [this.$lang.cancellationPolicy.table.createdAt],
                perPage:25,
            },
        };
    },
    mounted() {
        let self = this;
        store.commit("showLoader", false);
        self.dismissCountDown = 0;
        self.dismissCountDownS = 0;
        if (localStorage.getItem("showAlert") !== "") {
            this.setAlert(true);
        }
        this.setAlert(false);
        localStorage.setItem("showAlert", "");
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                if (route.query && route.query.page) {
                    this.activePage = Number(route.query.page);
                }
            },
        },
    },
    methods: {
        setAlert(value) {
            this.showAlert = value;
        },
        pageChange(val) {
            this.$router.push({ query: { page: val } });
        },
        onDataLoaded(data) {
            // console.log("data.data.data",data.data.data);
        },
        removePercentage(value) {
            if(value){
                return value.replace('%', '');
            }
            return value;
        },
        editTableRow(item) {
            let self = this;
            const id = item;
            self.editId = item;
            axios
                .get(self.viewUrlApi(self.module, id), self.model)
                .then(function (response) {
                    if (response) {
                        const responseData = response.data.data;
                        self.cancellationPolicyUpdate.id = responseData.id;
                        self.cancellationPolicyUpdate.hoursBefore = responseData.hoursBefore;
                        self.cancellationPolicyUpdate.karmaPoint = responseData.karmaPoint;
                        self.cancellationPolicyUpdate.returnPercentage = self.removePercentage(responseData.returnPercentage) || '';
                    } else {
                        self.data = [];
                    }
                });
            self.largeModal = true;
        },
        onSubmit() {
            let self = this;
            const editId = self.cancellationPolicyUpdate.id;
            setTimeout(() => {
                const postData = {
                    hours_before: self.cancellationPolicyUpdate.hoursBefore,
                    karma_point: self.cancellationPolicyUpdate.karmaPoint,
                    return_percentage: self.cancellationPolicyUpdate.returnPercentage,
                };
                
                axios
                .post(self.editUrlApi(self.module, editId), postData)
                .then(function (response) {
                    self.submitted = false; //Enable Button

                    if (response.data.code === 200) {
                        self.largeModal = false;
                        self.$refs.myTable.refresh();
                        self.messageColor = "success";
                        self.err_msg = response.data.message;
                        self.dismissCountDown = 10;

                    } else {
                        self.messageColorModal = "danger";
                        self.err_msg = response.data.message;
                        self.dismissCountDownModal = 10;
                    }
                })
                .catch(function (error) {
                    if (error.response.data.error) {
                        var data = error.response.data.error.toString();
                    } else {
                        var data = error.response.data.message;
                    }
                    self.messageColorModal = "danger";
                    self.err_msg = data;
                    self.dismissCountDownModal = 10;
                    self.submitted = false; //Enable Button
                });
          }, 500);
        }
    },
};
</script>
